import BoundaryError from 'log/components/BoundaryError'
import React, { useEffect } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import AccountAction from '../../account/actions/AccountAction'
import SelectDropdown from '../../components/forms/SelectDropdown'
import AppBar from '../../components/navbar/AppBar'
import SlideNav from '../../components/navbar/SlideNav'
import SieauTooltip from '../../components/tooltip/SieauTooltip'
import SSEActions from '../../sse/actions/SSEActions'
import {
    SSE_CITY_REFRESH, SSE_CONTACT_REFRESH, SSE_CONTRIBUTOR_REFRESH, SSE_HYDRO_REFRESH,
    SSE_PARAMETER_REFRESH, SSE_PIEZO_REFRESH, SSE_PLUVIO_REFRESH, SSE_QUALITO_REFRESH,
    SSE_TAXON_REFRESH,
    SSE_UNIT_REFRESH,
} from '../../sse/constants/EventsConstants'
import QualityAction from 'quality/actions/QualityAction'
import AdministrationAction from 'administration/actions/AdministrationAction'
import HomeAction from 'home/actions/HomeAction'
import ReferencialAction from 'referencial/action/ReferencialAction'
import { getLogin } from 'utils/SettingUtils'
import { TIMEZONE_INTEGRATION, TIMEZONE_LOCAL } from 'utils/DateUtil'
import moment from 'moment-timezone'
import useAccountSetting from 'utils/customHook/useAccountSetting'
import { Outlet } from 'react-router'
import CityAction from '../../referencial/components/city/actions/CityAction'
import ParameterAction from '../../referencial/components/parameter/actions/ParameterAction'
import UnitAction from '../../referencial/components/unit/actions/UnitAction'
import TaxonAction from '../../referencial/components/taxon/actions/TaxonAction'
import ContributorAction from '../../referencial/components/contributor/actions/ContributorAction'
import ContactAction from '../../referencial/components/contact/actions/ContactAction'
import PiezometryThunk from '../../piezometry/actions/PiezometryThunk'
import HydrometryThunk from '../../hydrometry/actions/HydrometryThunk'
import PluviometryThunk from '../../pluviometry/actions/PluviometryThunk'

const manageLog = (log) => {
    if ((window.location.href || document.URL).split('#')[0].includes('localhost')) {
        // ne pas supp c'est volontaire
        console.log(`SSECall : ${log}`)
    }
}

// eslint-disable-next-line no-unused-vars
const SSE = () => {
    const dispatch = useDispatch()

    // const handleJobCompleted = event => {
    //     const { job } = JSON.parse(event.data)
    //     const jobCompleted = template(i18n.jobIDCompleted)({ jobId: job.name })
    //     dispatch(ToastrAction.success(jobCompleted))
    // }


    useEffect(() => {
        dispatch(SSEActions.connect())
        dispatch(SSEActions.subscribe(SSE_CITY_REFRESH, () => {
            manageLog('SSE city refresh received')
            dispatch(CityAction.fetchCities(true))
        }))
        dispatch(SSEActions.subscribe(SSE_PARAMETER_REFRESH, () => {
            manageLog('SSE parameters refresh received')
            dispatch(ParameterAction.fetchParameters(true))
        }))
        dispatch(SSEActions.subscribe(SSE_UNIT_REFRESH, () => {
            manageLog('SSE units refresh received')
            dispatch(UnitAction.fetchUnits(true))
        }))
        dispatch(SSEActions.subscribe(SSE_TAXON_REFRESH, () => {
            manageLog('SSE taxons refresh received')
            dispatch(TaxonAction.fetchTaxons())
        }))
        dispatch(SSEActions.subscribe(SSE_CONTRIBUTOR_REFRESH, () => {
            manageLog('SSE contributors refresh received')
            dispatch(ContributorAction.fetchContributors(true))
        }))
        dispatch(SSEActions.subscribe(SSE_CONTACT_REFRESH, () => {
            manageLog('SSE contacts refresh received')
            dispatch(ContactAction.fetchContacts(true))
        }))
        dispatch(SSEActions.subscribe(SSE_QUALITO_REFRESH, () => {
            manageLog('SSE qualito refresh received')
            dispatch(QualityAction.fetchQualitometersLight(true))
        }))
        dispatch(SSEActions.subscribe(SSE_PIEZO_REFRESH, () => {
            manageLog('SSE piezo refresh received')
            dispatch(PiezometryThunk.fetchPiezometersLight({ forceFetch: true }))
        }))
        dispatch(SSEActions.subscribe(SSE_HYDRO_REFRESH, () => {
            manageLog('SSE hydro refresh received')
            dispatch(HydrometryThunk.fetchHydrometricStations({ forceFetch: true }))
        }))
        dispatch(SSEActions.subscribe(SSE_PLUVIO_REFRESH, () => {
            manageLog('SSE pluvio refresh received')
            dispatch(PluviometryThunk.fetchPluviometers({ forceFetch: true }))
        }))
        // dispatch(SSEActions.subscribe(JOB_COMPLETED, handleJobCompleted))
        return () => {
            dispatch(SSEActions.stop())
        }
    }, [])

    return null
}

const SieauApp = () => {
    const dispatch = useDispatch()

    const {
        stationTypes,
        settings,
        accountHabilitations,
    } = useSelector(store => ({
        stationTypes: store.ReferencialReducer.stationTypes,
        settings: store.AdministrationReducer.settings,
        accountHabilitations: store.AccountReducer.accountHabilitations,
    }), shallowEqual)

    const timezone = useAccountSetting('usedTimezone')

    const login = getLogin()

    useEffect(() => {
        dispatch(QualityAction.fetchQualityIndicators())
        dispatch(AdministrationAction.fetchPictos())
        dispatch(HomeAction.fetchThemeLayers())
        dispatch(AdministrationAction.fetchSettings())
        dispatch(AdministrationAction.fetchCartographyThemes())
        dispatch(ReferencialAction.fetchStationTypes())
    }, [])

    useEffect(() => {
        switch (timezone) {
            case TIMEZONE_INTEGRATION: moment.tz.setDefault('Europe/London'); break
            case TIMEZONE_LOCAL: moment.tz.setDefault(); break
            default: moment.tz.setDefault()
        }
    }, [timezone])

    useEffect(() => {
        dispatch(AccountAction.fetchUser(login))
        dispatch(AccountAction.fetchAccountStatistics(login))
    }, [login])

    return !!stationTypes.length && !!settings.length && !!accountHabilitations.length && (
        <div className='body-blue'>
            <SSE />
            <SelectDropdown />
            <div id='sieauApp' style={{ minHeight: '100vh' }}>
                <AppBar />
                <SlideNav />
                <BoundaryError>
                    <div style={{ backgroundColor: '#e7eaef' }}>
                        <Outlet />
                    </div>
                </BoundaryError>
                <SieauTooltip />
            </div>
        </div>
    )
}

export default SieauApp
